//redirect to /update.html if we try to request a non-existent endpoint. 
// this is to remove the service worker from the browser cache
// and force the browser to load the new version of the app

export default () => {
  console.log('Updating to remove Service Worker.');
  window.location.replace('/update.html');
}